<template>
  <v-container>
    <v-layout row wrap>
      <v-flex>
        <v-tabs grow class="mb-4" v-model="selectedtab">
          <template v-for="sector in sectors">
            <v-tab :key="'tab' + sector.id">{{ sector.label }}</v-tab>
            <v-tab-item :key="'tabitem' + sector.id">
              <v-container grid-list-md ma-0 pa-0>
                <v-layout row wrap class="my-2">
                  <v-flex
                    xs12
                    sm6
                    :key="'dtcard' + area.id"
                    v-for="area in areas.filter(
                      (element) => element.sector_id == sector.id
                    )"
                  >
                    <v-card class>
                      <v-card-text>
                        <h1>{{ area.label }}</h1>
                        <v-data-table
                          :key="'dt' + area.id"
                          hide-actions
                          :headers="overviewHeaders"
                          :items="
                            organisations.filter(
                              (element) => element.area_id == area.id
                            )
                          "
                        >
                          <template v-slot:no-data>
                            <v-alert :value="true" color="error" icon="warning"
                              >Ingen avdelinger her</v-alert
                            >
                          </template>
                          <template v-slot:headers="props">
                            <tr>
                              <th align="left">
                                {{ GET_ORDLYD && GET_ORDLYD.org_department }}
                              </th>
                              <th align="left">Status</th>
                            </tr>
                          </template>
                          <template v-slot:items="props">
                            <tr
                              :class="{
                                'red lighten-1': props.item.status == 0 || !props.item.status,
                                'yellow lighten-1': props.item.status == 1,
                                'green lighten-1': props.item.status == 2,
                              }"
                              @click="props.expanded = !props.expanded"
                            >
                              <td>{{ props.item.label }}</td>
                              <td>
                                <template v-if="props.item.status == 0"
                                  >Ingen respons</template
                                >
                                <template v-else-if="props.item.status == 1">
                                  Gjennomført
                                  {{ props.item.overallstatus.toFixed(0) }}
                                  %
                                </template>
                                <template v-else-if="props.item.status == 2">
                                  Fullført
                                </template>
                                <template v-else>
                                  Ikke begynt
                                </template>
                                
                              </td>
                            </tr>
                          </template>
                          <template v-slot:expand="props">
                            <v-container grid-list-md>
                              <v-layout row wrap v-if="props.item.status > 0">
                                <v-flex xs12>
                                  <v-card>
                                    <v-card-text>
                                      <span class="title">{{
                                        GET_ORDLYD &&
                                          GET_ORDLYD.org_avdeling_target
                                      }}</span>
                                      <div
                                        class="subheading"
                                        style="white-space:pre-wrap;"
                                        v-text="
                                          props.item.response.organisationtarget
                                        "
                                      ></div>
                                    </v-card-text>
                                  </v-card>
                                </v-flex>
                                <v-flex xs12>
                                  <v-card>
                                    <v-card-text>
                                      <span class="title">{{
                                        GET_ORDLYD &&
                                          GET_ORDLYD.org_avdeling_subtarget
                                      }}</span>
                                      <div
                                        class="subheading"
                                        style="white-space:pre-wrap;"
                                        v-text="
                                          props.item.response
                                            .organisationsubtargets
                                        "
                                      ></div>
                                    </v-card-text>
                                  </v-card>
                                </v-flex>
                                <v-flex xs12 sm4>
                                  <v-card>
                                    <v-card-text>
                                      <div class="title">Generelt</div>

                                      <v-text-field
                                        readonly
                                        :value="props.item.response.place"
                                        :label="GET_ORDLYD && GET_ORDLYD.place"
                                      ></v-text-field>
                                      <v-text-field
                                        readonly
                                        :value="
                                          props.item.response.date.slice(0, 10)
                                        "
                                        :label="GET_ORDLYD && GET_ORDLYD.date"
                                      ></v-text-field>
                                      <v-text-field
                                        readonly
                                        :value="
                                          props.item.response.participants
                                        "
                                        :label="
                                          GET_ORDLYD && GET_ORDLYD.participiants
                                        "
                                      ></v-text-field>
                                    </v-card-text>
                                  </v-card>
                                </v-flex>
                                <v-flex xs12 sm8>
                                  <v-card>
                                    <v-card-text>
                                      <div class="title">
                                        {{
                                          GET_ORDLYD &&
                                            GET_ORDLYD.main_progression
                                        }}
                                      </div>
                                      <span>{{
                                        GET_ORDLYD && GET_ORDLYD.main_activities
                                      }}</span>
                                      <v-progress-linear
                                        color="success"
                                        :value="props.item.activitystatus * 100"
                                      ></v-progress-linear>
                                      <span>{{
                                        GET_ORDLYD && GET_ORDLYD.main_evaluering
                                      }}</span>
                                      <v-progress-linear
                                        color="success"
                                        :value="
                                          props.item.evaluationstatus * 100
                                        "
                                      ></v-progress-linear>
                                      <v-btn
                                        block
                                        color="primary"
                                        @click="
                                          currentSelectedOrganisationId =
                                            props.item.id;
                                          viewdetailsdialog = true;
                                        "
                                        >Se detaljer</v-btn
                                      >
                                    </v-card-text>
                                  </v-card>
                                </v-flex>
                              </v-layout>
                              <v-layout row v-else>
                                <v-flex class="pa-0 ma-0">
                                  <v-card color="info">
                                    <v-card-text>
                                      <span class="subheading">
                                        Ingen responser er registrert her enda.
                                      </span>
                                    </v-card-text>
                                  </v-card>
                                </v-flex>
                              </v-layout>
                            </v-container>
                          </template>
                        </v-data-table>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-tab-item>
          </template>
        </v-tabs>
      </v-flex>
    </v-layout>
    <v-dialog
      v-model="viewdetailsdialog"
      v-if="currentSelectedResponse"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card color="primary lighten-3">
        <v-toolbar dark color="primary" fixed>
          <v-toolbar-title>Detaljer</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn @click="viewdetailsdialog = false" flat>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-container grid-list-md>
          <v-layout row wrap fill-height>
            <v-flex xs12 fill-height d-flex>
              <v-card fill-height>
                <v-card-title class="headline">Generelt</v-card-title>
                <v-card-text>
                  <v-layout row fill-height justify-space-between wrap>
                    <v-card color="grey lighten-3" class="my-3 pa-3 d-flex">
                      <span class="title">{{
                        GET_ORDLYD && GET_ORDLYD.org_area
                      }}</span>
                      <v-spacer></v-spacer>
                      <span class="subtitle text-xs-right text-no-wrap ml-3">
                        {{
                          currentSelectedResponse.area_label || "-ikke besvart-"
                        }}
                      </span>
                    </v-card>
                    <v-card color="grey lighten-3" class="my-3 pa-3 d-flex">
                      <span class="title">{{
                        GET_ORDLYD && GET_ORDLYD.org_department
                      }}</span>
                      <v-spacer></v-spacer>
                      <span class="subtitle text-xs-right text-no-wrap ml-3">
                        {{ currentSelectedResponse.label || "-ikke besvart-" }}
                      </span>
                    </v-card>
                    <v-card color="grey lighten-3" class="my-3 pa-3 d-flex">
                      <span class="title">{{
                        GET_ORDLYD && GET_ORDLYD.place
                      }}</span>
                      <v-spacer></v-spacer>
                      <span class="subtitle text-xs-right text-no-wrap ml-3">
                        {{
                          currentSelectedResponse.response.place ||
                            "-ikke besvart-"
                        }}
                      </span>
                    </v-card>
                    <v-card color="grey lighten-3" class="my-3 pa-3 d-flex">
                      <span class="title">{{
                        GET_ORDLYD && GET_ORDLYD.date
                      }}</span>
                      <v-spacer></v-spacer>
                      <span class="subtitle text-xs-right text-no-wrap ml-3">
                        {{
                          currentSelectedResponse.response.date.slice(0, 10) ||
                            "-ikke besvart-"
                        }}
                      </span>
                    </v-card>
                    <v-card color="grey lighten-3" class="my-3 pa-3 d-flex">
                      <span class="title">{{
                        GET_ORDLYD && GET_ORDLYD.participiants
                      }}</span>
                      <v-spacer></v-spacer>
                      <span class="subtitle text-xs-right text-no-wrap ml-3">
                        {{
                          currentSelectedResponse.response.participants ||
                            "-ikke besvart-"
                        }}
                      </span>
                    </v-card>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12 sm6>
              <v-card>
                <v-card-title class="headline">{{
                  GET_ORDLYD && GET_ORDLYD.main_target
                }}</v-card-title>
                <v-card-text>
                  <!-- <pre v-text="currentSelectedResponse.response"></pre> -->
                  <v-card color="grey lighten-3" class="my-3 pa-3">
                    <v-layout justify-space-between>
                      <v-flex>
                        <span class="title">{{
                          GET_ORDLYD && GET_ORDLYD.org_avdeling_target
                        }}</span>
                      </v-flex>
                    </v-layout>
                    <div
                      class="subtitle"
                      v-if="currentSelectedResponse.response.organisationtarget"
                    >
                      {{ currentSelectedResponse.response.organisationtarget }}
                    </div>
                    <div class="subtitle" v-else>Ingen kommentar</div>
                  </v-card>

                  <v-card color="grey lighten-3" class="my-3 pa-3">
                    <v-layout justify-space-between>
                      <v-flex>
                        <span class="title">{{
                          GET_ORDLYD && GET_ORDLYD.org_avdeling_subtarget
                        }}</span>
                      </v-flex>
                    </v-layout>
                    <div
                      class="subtitle"
                      v-if="
                        currentSelectedResponse.response.organisationsubtargets
                      "
                    >
                      {{
                        currentSelectedResponse.response.organisationsubtargets
                      }}
                    </div>
                    <div class="subtitle" v-else>Ingen kommentar</div>
                  </v-card>

                  <v-card color="grey lighten-3" class="my-3 pa-3">
                    <v-layout justify-space-between>
                      <v-flex>
                        <span class="title">{{
                          GET_ORDLYD &&
                            GET_ORDLYD.org_avdeling_tilstedeverelse_target
                        }}</span>
                      </v-flex>
                    </v-layout>

                    <template
                      v-for="(target, index) in currentSelectedResponse.response
                        .targetcomputed"
                    >
                  
                    <!-- <v-flex xs6 v-if="plan.planning !== undefined && index <= 2">Måltall {{ Number(plan.planning.year) + 2 - index}} </v-flex>
                    <v-flex xs6 v-if="plan.planning !== undefined && index > 2">Nærvær {{ Number(plan.planning.year) + 2 - index}}</v-flex>  -->
                      <span
                        class="font-weight-bold"
                        :key="`overskrift${target.label}`"
                        >{{ Number(plan.year) + 2 - index }}</span
                      >
                      <v-card
                        :key="target.label"
                        class="my-3 pa-0"
                        color="grey lighten-2"
                      >
                        <v-card-text>
                          <v-layout row justify-space-between>
                            <span class="body-1">{{
                              GET_ORDLYD &&
                                GET_ORDLYD.org_avdeling_tilstedeverelse_target_short_desc
                            }}</span>
                            <span>{{ target.short }}%</span>
                          </v-layout>
                        </v-card-text>
                      </v-card>
                    </template>
                  </v-card>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12 sm6>
              <v-card>
                <v-card-title class="headline">{{
                  GET_ORDLYD && GET_ORDLYD.evaluering_overskrift
                }}</v-card-title>
                <v-card-text>
                  <v-card
                    class="my-3 pa-3"
                    :class="{
                      'green lighten-2': evaluation.completed == 1,
                      'red darken-1 white--text': evaluation.completed == 2,
                      'grey lighten-3': !evaluation.completed,
                    }"
                    v-for="evaluation in currentSelectedResponse.response
                      .evaluations"
                    :key="`evaluation_${evaluation.id}`"
                  >
                    <v-layout justify-space-between>
                      <v-flex>
                        <span class="title">{{ evaluation.question }}</span>
                      </v-flex>
                      <v-flex class="text-xs-right text-no-wrap">
                        <span class="subtitle" v-if="evaluation.completed == 1"
                          >Ja</span
                        >
                        <span
                          class="subtitle"
                          v-else-if="evaluation.completed == 2"
                          >Nei</span
                        >
                        <span class="subtitle" v-else>-ikke besvart-</span>
                      </v-flex>
                    </v-layout>
                    <div class="subtitle" v-if="evaluation.text">
                      Kommentar: {{ evaluation.text }}
                    </div>
                    <div class="subtitle" v-else>Ingen kommentar</div>
                  </v-card>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12>
              <v-card>
                <v-card-title class="headline">{{
                  GET_ORDLYD && GET_ORDLYD.org_overview
                }}</v-card-title>
                <v-card-text>
                  <v-card
                    :class="{
                      'green lighten-3': activity.done,
                      'grey lighten-3': !activity.done,
                    }"
                    class="my-3 pa-3"
                    v-for="activity in currentSelectedResponse.response.activities.filter(
                      (act) => act.level == 'kommune'
                    )"
                    :key="`activity${activity.id}`"
                  >
                    <v-layout justify-space-between>
                      <v-flex>
                        <span class>{{ activity.measure }}</span>
                      </v-flex>
                    </v-layout>
                    <v-layout>
                      <v-flex xs3>
                        <span>{{ GET_ORDLYD && GET_ORDLYD.schedule }}</span>
                        <span class="ml-3 font-weight-bold">
                          {{ activity.schedule || "-ikke utfylt-" }}
                        </span>
                      </v-flex>
                      <v-flex xs3>
                        <span>{{ GET_ORDLYD && GET_ORDLYD.category }}</span>
                        <span class="ml-3 font-weight-bold">
                          {{ activity.category || "-ikke utfylt-" }}
                        </span>
                      </v-flex>
                      <v-flex xs3>
                        <span>{{
                          GET_ORDLYD && GET_ORDLYD.responsibility
                        }}</span>
                        <span class="ml-3 font-weight-bold">
                          {{ activity.responsibility || "-ikke utfylt-" }}
                        </span>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12>
              <v-card>
                <v-card-title class="headline">{{
                  GET_ORDLYD && GET_ORDLYD.org_avdeling_mandatory_activities
                }}</v-card-title>
                <v-card-text>
                  <v-card
                    :class="{
                      'green lighten-3': activity.done,
                      'grey lighten-3': !activity.done,
                    }"
                    class="my-3 pa-3"
                    v-for="activity in currentSelectedResponse.response.activities.filter(
                      (act) => act.level == 'avdeling'
                    )"
                    :key="`activity${activity.id}`"
                  >
                    <v-layout justify-space-between>
                      <v-flex>
                        <span class>{{ activity.measure }}</span>
                      </v-flex>
                    </v-layout>
                    <v-layout>
                      <v-flex xs3>
                        <span>{{ GET_ORDLYD && GET_ORDLYD.schedule }}</span>
                        <span class="ml-3 font-weight-bold">
                          {{ activity.schedule || "-ikke utfylt-" }}
                        </span>
                      </v-flex>
                      <v-flex xs3>
                        <span>{{ GET_ORDLYD && GET_ORDLYD.category }}</span>
                        <span class="ml-3 font-weight-bold">
                          {{ activity.category || "-ikke utfylt-" }}
                        </span>
                      </v-flex>
                      <v-flex xs3>
                        <span>{{
                          GET_ORDLYD && GET_ORDLYD.responsibility
                        }}</span>
                        <span class="ml-3 font-weight-bold">
                          {{ activity.responsibility || "-ikke utfylt-" }}
                        </span>
                      </v-flex>
                      <v-flex xs3>
                        <span>{{ GET_ORDLYD && GET_ORDLYD.done }}</span>
                        <template v-if="activity.done == 1">
                          <span class="ml-3 font-weight-bold">
                            {{
                              activity.doneDate &&
                                activity.doneDate.slice(0, 10)
                            }}
                          </span>
                        </template>
                        <span v-else class="ml-3 font-weight-bold"
                          >-ikke
                          {{
                            GET_ORDLYD && GET_ORDLYD.done.toLowerCase()
                          }}-</span
                        >
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-card-text>
              </v-card>
            </v-flex>

            <v-flex xs12>
              <v-card>
                <v-card-title class="headline">{{
                  GET_ORDLYD && GET_ORDLYD.org_avdeling_other_activities
                }}</v-card-title>
                <v-card-text>
                  <v-card
                    :class="{
                      'green lighten-3': activity.done,
                      'grey lighten-3': !activity.done,
                    }"
                    class="my-3 pa-3"
                    v-for="activity in currentSelectedResponse.response.activities.filter(
                      (act) => act.level == 'avd_ovrige_aktiviter'
                    )"
                    :key="`activity${activity.id}`"
                  >
                    <v-layout justify-space-between>
                      <v-flex>
                        <span class>{{ activity.measure }}</span>
                      </v-flex>
                    </v-layout>
                    <v-layout>
                      <v-flex xs3>
                        <span>{{ GET_ORDLYD && GET_ORDLYD.schedule }}</span>
                        <span class="ml-3 font-weight-bold">
                          {{ activity.schedule || "-ikke utfylt-" }}
                        </span>
                      </v-flex>
                      <v-flex xs3>
                        <span>{{ GET_ORDLYD && GET_ORDLYD.category }}</span>
                        <span class="ml-3 font-weight-bold">
                          {{ activity.category || "-ikke utfylt-" }}
                        </span>
                      </v-flex>
                      <v-flex xs3>
                        <span>{{
                          GET_ORDLYD && GET_ORDLYD.responsibility
                        }}</span>
                        <span class="ml-3 font-weight-bold">
                          {{ activity.responsibility || "-ikke utfylt-" }}
                        </span>
                      </v-flex>
                      <v-flex xs3>
                        <span>{{ GET_ORDLYD && GET_ORDLYD.done }}</span>
                        <template v-if="activity.done == 1">
                          <span class="ml-3 font-weight-bold">
                            {{
                              activity.doneDate &&
                                activity.doneDate.slice(0, 10)
                            }}
                          </span>
                        </template>
                        <span v-else class="ml-3 font-weight-bold"
                          >-ikke
                          {{
                            GET_ORDLYD && GET_ORDLYD.done.toLowerCase()
                          }}-</span
                        >
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12>
              <v-card>
                <v-card-title class="headline">{{
                  GET_ORDLYD && GET_ORDLYD.org_avdeling_hms_activities
                }}</v-card-title>
                <v-card-text>
                  <v-card
                    :class="{
                      'green lighten-3': activity.done,
                      'grey lighten-3': !activity.done,
                    }"
                    class="my-3 pa-3"
                    v-for="activity in currentSelectedResponse.response.activities.filter(
                      (act) => act.level == 'bruk_av_hms_og_als'
                    )"
                    :key="`activity${activity.id}`"
                  >
                    <v-layout justify-space-between>
                      <v-flex>
                        <span class>{{ activity.measure }}</span>
                      </v-flex>
                    </v-layout>
                    <v-layout>
                      <v-flex xs3>
                        <span>{{ GET_ORDLYD && GET_ORDLYD.schedule }}</span>
                        <span class="ml-3 font-weight-bold">
                          {{ activity.schedule || "-ikke utfylt-" }}
                        </span>
                      </v-flex>
                      <v-flex xs3>
                        <span>{{ GET_ORDLYD && GET_ORDLYD.category }}</span>
                        <span class="ml-3 font-weight-bold">
                          {{ activity.category || "-ikke utfylt-" }}
                        </span>
                      </v-flex>
                      <v-flex xs3>
                        <span>{{
                          GET_ORDLYD && GET_ORDLYD.responsibility
                        }}</span>
                        <span class="ml-3 font-weight-bold">
                          {{ activity.responsibility || "-ikke utfylt-" }}
                        </span>
                      </v-flex>
                      <v-flex xs3>
                        <span>{{ GET_ORDLYD && GET_ORDLYD.done }}</span>
                        <template v-if="activity.done == 1">
                          <span class="ml-3 font-weight-bold">
                            {{
                              activity.doneDate &&
                                activity.doneDate.slice(0, 10)
                            }}
                          </span>
                        </template>
                        <span v-else class="ml-3 font-weight-bold"
                          >-ikke
                          {{
                            GET_ORDLYD && GET_ORDLYD.done.toLowerCase()
                          }}-</span
                        >
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  watch: {
    selectedtab(newVal) {
      localStorage.setItem("selectedsectortab", newVal);
    },
    GET_MANUALLYSELECTEDPLAN() {
      this.ShowCustomerOverView();
    },
  },
  computed: {
    ...mapGetters(["GET_ORDLYD", "GET_MANUALLYSELECTEDPLAN"]),
    currentSelectedResponse() {
      return this.organisations.find(
        (el) => el.id == this.currentSelectedOrganisationId
      );
    },
  },
  data() {
    return {
      viewdetailsdialog: false,
      currentSelectedOrganisationId: null,
      selectedtab: localStorage.getItem("selectedsectortab"),
      customer: null,
      organisations: [],
      areas: [],
      sectors: [],
      responses: [],
      activities: [],
      plan: null,
      overviewHeaders: [
        {
          text: this.GET_ORDLYD && this.GET_ORDLYD.org_department,
          value: "label",
          sortable: true,
        },
        { text: "Status", value: "overallstatus", sortable: true },
      ],
      departmenTypes: [
        { text: "-", value: "" },
        { text: this.GET_ORDLYD && this.GET_ORDLYD.org_area, value: "etat" },
        {
          text: this.GET_ORDLYD && this.GET_ORDLYD.org_department,
          value: "avdeling",
        },
      ],
    };
  },
  methods: {
    ...mapActions(["GET_THIS_CUSTOMER_OVERVIEW", "GET_PLAN"]),
    ShowCustomerOverView() {
      this.viewdetailsdialog = false;
      this.currentSelectedOrganisationId = null;
      this.selectedtab = null;
      this.customer = null;
      this.organisations = [];
      this.areas = [];
      this.sectors = [];
      this.responses = [];
      this.activities = [];
      this.plan = null;

      this.GET_THIS_CUSTOMER_OVERVIEW()
        .then((resp) => {
          this.customer = resp.data;
          this.categories = resp.data.categories;
          this.areas = resp.data.areas.sort((a, b) => {
            return a.label < b.label ? -1 : a.label > b.label ? 1 : 0;
          });
          this.organisations = resp.data.organisations;
          // this.sectors = resp.data.sectors.sort((a, b) => {
          //   return a.label < b.label ? -1 : a.label > b.label ? 1 : 0;
          // });

          const isRegularUser = this.$store.getters.GET_USER.role === 'user';
          console.log(isRegularUser)
          this.sectors = resp.data.sectors
            .filter(sector => !(isRegularUser && sector.id === 10))
            .sort((a,b) => (a.label < b.label ? -1 : a.label > b.label ? 1 : 0))

          this.plan = resp.data.planning.find(plan => plan.id === resp.data.responses[0].planningid);

          this.organisations.forEach((element) => {
            element.response = this.customer.responses.find(
              (resp) => resp.organisationid == element.id
            );
            element.activitystatus = 0;
            element.activitiesdone = 0;
            element.evaluationstatus = 0;
            element.evaluationsdone = 0;
            element.overallstatus = 0;
            if (!element.response) {
              element.status = 0;
            } else {
              element.status = 1;
              if (
                element.response.activities &&
                element.response.activities.length > 0
              ) {
                element.activitiesdone = element.response.activities
                  .filter((element) => element.level != "kommune")
                  .reduce((acc, curr) => acc + (curr.done || 0), 0);
                element.activitystatus =
                  element.activitiesdone /
                  element.response.activities.filter(
                    (element) => element.level != "kommune"
                  ).length;
              }
              if (
                element.response.evaluations &&
                element.response.evaluations.length > 0
              ) {
                element.evaluationsdone = element.response.evaluations.reduce(
                  (acc, curr) => acc + (curr.completed != 0 ? 1 : 0),
                  0
                );
                element.evaluationstatus =
                  element.evaluationsdone / element.response.evaluations.length;
              }

              element.overallstatus =
                ((element.evaluationstatus + element.activitystatus) / 2) * 100;

              if (element.overallstatus == 100) {
                element.status = 2;
              }

              element.response.targetcomputed = [
                {
                  label: "Måltall 2026",
                  short: element.response.targetnumber3years_short,
                  long: element.response.targetnumber3years_long,
                },
                {
                  label: "Måltall 2025",
                  short: element.response.targetnumber2years_short,
                  long: element.response.targetnumber2years_long,
                },
                {
                  label: "Måltall 2024",
                  short: element.response.targetnumber1years_short,
                  long: element.response.targetnumber1years_long,
                },
                {
                  label: "Nærvær 2023",
                  short: element.response.absencecurrenthalfyear_short,
                  long: element.response.absencecurrenthalfyear_long,
                },
                {
                  label: "Nærvær 2022",
                  short: element.response.absence1years_short,
                  long: element.response.absence1years_long,
                },
                {
                  label: "Nærvær 2021",
                  short: element.response.absence2years_short,
                  long: element.response.absence2years_long,
                },
              ];
            }
          });
        })

        .catch((ex) => {
          console.error(ex);
        });
    },
  },
  mounted() {
    this.ShowCustomerOverView();
  },
};
</script>

<style scoped>
.oversikt tbody td {
  outline: 1px solid black !important;
  outline-offset: -2px !important;
}
</style>
